import { shareGetDeviceType } from '../api/modules/public'
import {
  baseType,
  displayscreenType,
  gatewayType,
  relayType
} from '@/utils/convert'

// 用于转换convert图标到v-select的select
import { icon, deviceTypeListConvert } from './convert'
import { getIsSys } from './permission'
import matchDeviceType from './matchDeviceType'
import { sensorType } from '@/utils/dict/sensor'
// 前后端命名映射
const nameNat = {
  sensor: 'sensor',
  gateway: 'gateway',
  display: 'display',
  realy: 'relay',
  base: 'plinth',
  plinth: 'plinth'
}
export default function (type) {
  const arr = [
    {
      value: '',
      label: 'public.please',
      icon: 'el-icon-thumb'
    }
  ]
  if (typeof type === 'string') {
    Object.keys(icon[type]).forEach(key => {
      arr.push({
        value: key,
        label: icon[type][key].title,
        icon: icon[type][key].icon
      })
    })
  } else {
    Object.keys(type).forEach(key => {
      arr.push({
        value: key,
        label: type[key].title,
        icon: type[key] && type[key].icon
      })
    })
  }

  return arr
}

// 根据权限过滤掉客户  可自定义过滤条件 过滤条件即为paramsName
export const filterateSelection = function (selection, condition) {
  // 是否系统用户
  const isSys = getIsSys()

  // 系统管理员且未指定条件不需要额外处理
  if (isSys && !condition) return selection

  // 需要过滤的index 最后需要将此数组倒置  保证是从后开始移除
  let filterateIndex = []

  // 非系统管理员过滤掉客户
  for (let i = 0; i < selection.length; i++) {
    if (!condition && selection[i].paramsName === 'scopeName') {
      selection.splice(i, 1)
      break
    } else if (condition && condition.length) {
      if (
        condition.findIndex(item => item === selection[i].paramsName) !== -1
      ) {
        filterateIndex.push(i)
      }
    }
  }
  filterateIndex = filterateIndex.reverse()
  for (let i = 0; i < filterateIndex.length; i++) {
    selection.splice(filterateIndex[i], 1)
  }
  console.log(selection)
  return selection
}
// 从后端获取设备类型列表并去匹配Icon 添加到selectParam列表
export const getDeviceTypeToSelection = async function (type, selectItem) {
  // 长度才去操作
  if (selectItem.selectParam && !selectItem.selectParam.length) {
    // 经过命名映射  不管叫什么都能准确映射到后端对应的名称
    const res = await shareGetDeviceType(nameNat[type])
    let typeMap = {}
    switch (type) {
      case 'sensor':
        typeMap = sensorType
        break
      case 'gateway':
        typeMap = gatewayType
        break
      case 'display':
        typeMap = displayscreenType
        break
      case 'relay':
        typeMap = relayType
        break
      case 'base':
        typeMap = baseType
        break
      case 'plinth':
        typeMap = baseType
        break
    }
    selectItem.selectParam = matchDeviceType(res.result, typeMap)
    selectItem.selectParam.forEach(item => {
      item.label = deviceTypeListConvert[item.code]
    })
    selectItem.selectParam.splice(0, 0, {
      value: '',
      label: 'public.please',
      icon: 'el-icon-thumb'
    })
  }
}
